import { useMutation } from '@tanstack/react-query';
import { mindUpDiagnosisApi } from 'api/MindUp/mindUpDiagnosisApi';
import { DiagnosisUpdateReqeustType } from 'models/DCK/DCKApiTypes';
import { useLoadingStore } from 'store/useLoadingStore';

const usePurchaseCounselingMutation = () => {
    const { setLoading } = useLoadingStore();

    return useMutation({
        mutationFn: async (rqData: { diagnosisId: string; paymentId: string; token: string }) => {
            try {
                setLoading(true);

                const parsedRqData = { _id: rqData.diagnosisId, paymentId: rqData.paymentId } as DiagnosisUpdateReqeustType;
                const response = await mindUpDiagnosisApi.updateDiagnosisInfo(parsedRqData, rqData.token);

                if (response.status === 'ok') return response.data;
                throw new Error('API 응답 오류');
            } catch (error) {
                const errorMessage = error instanceof Error ? error.message : '알 수 없는 오류가 발생했습니다';
                throw new Error(errorMessage);
            } finally {
                setLoading(false);
            }
        },
        onSuccess: (data) => {},
        retry: 1, // 오류 시 재시도 횟수
    });
};

export default usePurchaseCounselingMutation;
